import type { ReactNode } from "react";

import useWhatsNewState from "~/pages/home/hooks/useWhatsNewState";
import WhatsNewContext from "~/pages/home/WhatsNewContext";

interface WhatsNewProviderProps {
	children: ReactNode;
}

const WhatsNewProvider = ({ children }: WhatsNewProviderProps) => {
	const home = useWhatsNewState();
	return <WhatsNewContext.Provider value={home}>{children}</WhatsNewContext.Provider>;
};
export default WhatsNewProvider;
